/* Auto-scrolling review carousel (Claude Design Handoff "Fitjeans Kundentext-Element",
   Review Slider.dc.html). Ported from the mockup's React/RAF logic to vanilla JS:
   the track's original cards are cloned once so scrollWidth doubles, then a RAF loop
   nudges scrollLeft and wraps at the halfway point for a seamless infinite loop. */
(function () {
  function initReviewSlider(track) {
    if (track.dataset.rsInit) return;
    track.dataset.rsInit = 'true';

    Array.prototype.slice.call(track.children).forEach(function (el) {
      track.appendChild(el.cloneNode(true));
    });

    var paused = false;
    var dragging = false;
    var speed = 0.4;
    var acc = 0;
    var startX = 0;
    var startScroll = 0;
    var resumeTimer = null;
    var last = null;

    function wrap() {
      var half = track.scrollWidth / 2;
      if (track.scrollLeft >= half) track.scrollLeft -= half;
      else if (track.scrollLeft < 0) track.scrollLeft += half;
    }

    function loop(now) {
      if (!track.isConnected) return;
      if (last === null) last = now;
      var dt = Math.min(now - last, 50);
      last = now;
      if (track.scrollWidth > track.clientWidth && !paused && !dragging) {
        acc += speed * (dt / 16.67);
        var step = Math.floor(acc);
        if (step >= 1) {
          acc -= step;
          track.scrollLeft += step;
          wrap();
        }
      }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    track.addEventListener('mouseenter', function () {
      paused = true;
    });
    track.addEventListener('mouseleave', function () {
      if (!dragging) paused = false;
    });

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      paused = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
      track.style.cursor = 'grabbing';
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      track.scrollLeft = startScroll - dx;
      wrap();
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      track.style.cursor = 'grab';
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        paused = false;
      }, 1200);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }

  function init() {
    document.querySelectorAll('[data-review-slider-track]').forEach(initReviewSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
